import React from 'react';

const AdmissionDetails = ({ admission, handleBackToTable, getStatusBadge }) => {
  if (!admission) return null;
  return (
    <div className="flex flex-col flex-1 min-h-0 mt-2">
      <div className="mb-4 flex-shrink-0">
        <button onClick={handleBackToTable} className="bg-gradient-to-r from-gray-600 to-gray-700 text-white px-4 py-2 rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl">
          <i className="pi pi-arrow-left text-sm"></i> Back to Admissions
        </button>
      </div>

      <div className="bg-white/90 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/20 flex gap-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="w-1/3 flex items-start justify-center z-10">
          <div className="w-72 h-72 rounded-2xl bg-gradient-to-br from-indigo-100 to-purple-100 overflow-hidden border-4 border-white shadow-xl flex items-center justify-center relative">
            {admission.imageUrl ? (
              <img src={admission.imageUrl} alt={`${admission.firstName} ${admission.lastName}`} className="object-cover w-full h-full" />
            ) : (
              <div className="text-6xl font-bold bg-gradient-to-br from-indigo-500 to-purple-600 bg-clip-text text-transparent">
                {((admission.firstName || '')[0] || '') + ((admission.lastName || '')[0] || '')}
              </div>
            )}
            <div className="absolute bottom-4 right-4 w-8 h-8 bg-green-500 rounded-full border-4 border-white flex items-center justify-center">
              <i className="pi pi-check text-white text-xs"></i>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2 space-y-6">
          <div className="flex items-center justify-between mb-2">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {admission.firstName} {admission.lastName}
              </h3>
            </div>

            <div className="flex items-center gap-4">
              <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                <i className="pi pi-id-card mr-2"></i> ADM0{admission.id}
              </span>
              {getStatusBadge(admission.status)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-100">
              <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
                <i className="pi pi-user mr-2"></i>Student Information
              </h4>
              <div className="space-y-2">
                <p className="text-sm"><span className="font-medium">Date of Birth:</span> {admission.dateOfBirth ? new Date(admission.dateOfBirth).toLocaleDateString() : '-'}</p>
                <p className="text-sm"><span className="font-medium">Gender:</span> {admission.gender ? admission.gender.charAt(0).toUpperCase() + admission.gender.slice(1) : '-'}</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-lg border border-green-100">
              <h4 className="text-sm font-semibold text-green-800 mb-3 flex items-center">
                <i className="pi pi-users mr-2"></i>Parent Information
              </h4>
              <div className="space-y-2">
                <p className="text-sm"><span className="font-medium">Name:</span> {admission.parentName}</p>
                <p className="text-sm"><span className="font-medium">Mobile:</span> {admission.parentPhone}</p>
                <p className="text-sm"><span className="font-medium">Email:</span> {admission.parentEmail}</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-4 rounded-lg border border-purple-100">
              <h4 className="text-sm font-semibold text-purple-800 mb-3 flex items-center">
                <i className="pi pi-graduation-cap mr-2"></i>Academic Details
              </h4>
              <div className="space-y-2">
                <p className="text-sm"><span className="font-medium">Class:</span>{admission.className}</p>
                <p className="text-sm"><span className="font-medium">Admission No:</span>ADM0{admission.id}</p>
                <p className="text-sm"><span className="font-medium">Admission Date:</span> {admission.admissionDate ? new Date(admission.admissionDate).toLocaleDateString() : '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionDetails;
